const CardSkeleton: React.FC = () => {
	return (
		<div className="border-stroke-secondary flex flex-col rounded-lg border shadow-sm">
			<div className="bg-surface-primary-pressed h-40 rounded-t-lg" />
			<div className="p-4">
				<div className="bg-surface-primary-pressed mb-2 h-4 rounded" />
				<div className="bg-surface-primary-pressed mb-2 h-4 rounded" />
				<div className="bg-surface-primary-pressed mb-4 h-4 rounded" />
				<div className="bg-surface-primary-pressed rounded-small mb-2 h-10" />
			</div>
		</div>
	);
};

export const LoadingCardsSkeleton: React.FC = () => {
	return (
		<div
			data-qa="suggested-petitions"
			className="grid animate-pulse grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
		>
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
		</div>
	);
};
